import { ReactNode } from 'react'
import { LoginPage } from '../pages/LoginPage'
import { useAuth } from '../hooks/useAuth'

interface Props {
  children: ReactNode
  requireAdmin?: boolean
}

export function ProtectedRoute({ children, requireAdmin = false }: Props) {
  const { isAuthenticated, isAdmin } = useAuth()

  if (!isAuthenticated) {
    return <LoginPage />
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <p className="text-red-600 dark:text-red-400 text-sm">You do not have permission to view this page.</p>
      </div>
    )
  }

  return <>{children}</>
}
